import { useToolbarGridMetrics } from "@-/dev.improve.haniverse.components.ui.toolbar.button.view";

/**
 * The height of a menu's header band: the toolbar control inside the surface's 1pt border, plus
 * the 4pt `headerOutset` the menus open with, so the close button lands where the trigger was.
 */
export function useToolbarMenuBandHeight(): number {
  const { diameter } = useToolbarGridMetrics();
  return diameter - 2 + 4;
}
